import type { ApprovalTask } from '@/features/attendance'

/**
 * What `GET /approvals/tasks/{id}/context` returns.
 *
 * `detail` is deliberately unknown here: the server types it as an object because the
 * workflow engine may not depend on any module's shapes, and the panel narrows on
 * `detailKind` rather than by sniffing fields.
 */
export interface TaskContext {
  task: ApprovalTask
  detail: unknown
  /** The entity key, so the client switches on a value rather than on a shape. */
  detailKind: string | null
  /**
   * Null when `detail` is what the module returned.
   *
   * A sentence when the module could not assemble it — the decision is still available, and
   * the screen says so instead of implying there is nothing to see.
   */
  unavailableReason: string | null
}

export const ENTITY_KEY_LABELS: Record<string, string> = {
  'leave.request': 'Leave request',
  'attendance.regularization': 'Attendance correction',
  'employee.transfer': 'Transfer',
  'request.generic': 'Request',
  'pro.case': 'PRO case',
  'timesheet.week': 'Timesheet',
}
